import { Box, Typography, Button } from "@mui/material";
import { customBlue } from "../../theme/palette";

interface NoAudioMicCheckStateProps {
  onRetry: () => void;
  onClose?: () => void;
}

export function NoAudioMicCheckState({
  onRetry,
  onClose,
}: NoAudioMicCheckStateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "center",
        px: 4,
        pt: 2,
        pb: 3,
        height: "100%",
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: "32px",
            fontWeight: 800,
            color: "#374151",
            mb: 4,
            lineHeight: 1.2,
          }}
        >
          Sorry, we can&apos;t hear you.
          <br />
          Raise your hand for help!
          <Box component="span" sx={{ ml: 1 }}>
            🖐️
          </Box>
        </Typography>

        <Box sx={{ mb: 4, textAlign: "left", width: "100%", ml: "-177px" }}>
          <Typography
            variant="body1"
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              color: "#374151",
              textAlign: "left",
            }}
          >
            Teacher Help Guides:
          </Typography>

          <Box sx={{ textAlign: "left" }}>
            <Typography
              component="li"
              sx={{
                fontSize: "16px",
                color: customBlue.primaryBlue,
                fontWeight: 800,
                listStyleType: "disc",
                ml: 2,
              }}
            >
              <Box
                component="a"
                href="https://flashlight360.zendesk.com/hc/en-us/articles/40756383593243-Tips-for-Successful-Microphone-Recording"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: customBlue.primaryBlue,
                  textDecoration: "none",
                  fontWeight: 800,
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                Tips for Successful Microphone Recording
              </Box>
            </Typography>

            <Typography
              component="li"
              sx={{
                fontSize: "16px",
                color: customBlue.primaryBlue,
                fontWeight: 800,
                listStyleType: "disc",
                ml: 2,
              }}
            >
              <Box
                component="a"
                href="https://flashlight360.zendesk.com/hc/en-us/articles/13474535763867-Microphone-Troubleshooting"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: customBlue.primaryBlue,
                  textDecoration: "none",
                  fontWeight: 800,
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                Microphone Troubleshooting
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            color: "#374151",
            fontWeight: 400,
            textAlign: "left",
            ml: "-20px",
          }}
        >
          Press <strong>Try Again</strong> when you&apos;re ready. You can do
          this!
          <Box
            component="span"
            sx={{
              ml: 1,
              cursor: onClose ? "pointer" : "default",
              "&:hover": onClose
                ? {
                    transform: "scale(1.1)",
                    transition: "transform 0.2s ease",
                  }
                : {},
            }}
            onClick={onClose}
            title={onClose ? "Skip mic check and close modal" : undefined}
          >
            🎉
          </Box>
        </Typography>

        <Button
          onClick={onRetry}
          variant="contained"
          sx={{
            minWidth: "120px",
            backgroundColor: customBlue.primaryBlue,
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "14px",
            px: 3,
            py: 1.5,
            whiteSpace: "nowrap",
            "&:hover": {
              backgroundColor: customBlue.primaryDark,
            },
          }}
        >
          try again
        </Button>
      </Box>
    </Box>
  );
}
